export const SEARCH_STOPWORDS = new Set([
  "video",
  "videos",
  "footage",
  "footages",
  "stock",
  "stockfootage",
  "stockvideo",
  "stockvideos",
  "clip",
  "clips",
  "film",
  "films",
  "reel",
  "reels",
  "broll",
  "b-roll",
]);

const normalizeToken = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "");

export const isSearchStopword = (value) =>
  SEARCH_STOPWORDS.has(normalizeToken(value));

export const stripSearchStopwords = (tokens) =>
  (Array.isArray(tokens) ? tokens : String(tokens || "").split(/\s+/))
    .map((token) => normalizeToken(token))
    .filter(Boolean)
    .filter((token) => !SEARCH_STOPWORDS.has(token));

export const stripSearchStopwordsFromQuery = (query) => {
  const original = String(query || "").trim();
  const tokens = stripSearchStopwords(original.split(/\s+/));
  return {
    original,
    tokens,
    query: tokens.join(" "),
  };
};
